module.exports = __webpack_public_path__ + "media/trail/rotate-right-green-1e59fdfc.svg";